import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

// Lista compartida entre registrarTodos() y cualquier selector de ícono (ej. catálogo de jugadas)
export const ICONOS_SVG: { nombre: string; archivo: string }[] = [
      { nombre: 'tt_am-dashboard',         archivo: 'amer-dashboard' },
      { nombre: 'tt_jugadores',            archivo: 'amer-jugador' },
      { nombre: 'tt_trofeo',               archivo: 'amer-torneo' },
      { nombre: 'tt_balon',                archivo: 'amer-anotacion' },
      { nombre: 'tt_am-alineacion',        archivo: 'amer-alineacion' },
      { nombre: 'tt_am-calendar',          archivo: 'amer-calendar' },
      { nombre: 'tt_amer-calendar-white',  archivo: 'calendar' },
      { nombre: 'tt_am-casco',             archivo: 'amer-casco' },
      { nombre: 'tt_am-ficha-jug',         archivo: 'amer-ficha-jug' },
      { nombre: 'tt_ayuda',                archivo: 'ayuda' },
      { nombre: 'tt_lesion',               archivo: 'bone' },
      { nombre: 'tt_invoice',              archivo: 'invoice' },
      { nombre: 'tt_birthday',             archivo: 'birthday' },
      { nombre: 'tt_flecha-baja-bloqueada', archivo: 'flecha-baja-bloqueada' },
      { nombre: 'blue-alert',              archivo: 'blue-alert' },
      { nombre: 'blue-archive',            archivo: 'blue-archive' },
      { nombre: 'blue-ball-americano',     archivo: 'blue-ball-americano' },
      { nombre: 'blue-ball-basket',        archivo: 'blue-ball-basket' },
      { nombre: 'blue-ball-beis',          archivo: 'blue-ball-beis' },
      { nombre: 'blue-ball-soccer',        archivo: 'blue-ball-soccer' },
      { nombre: 'blue-ball-summer',        archivo: 'blue-ball-summer' },
      { nombre: 'blue-ball-tennis',        archivo: 'blue-ball-tennis' },
      { nombre: 'blue-ball-tennis1',       archivo: 'blue-ball-tennis1' },
      { nombre: 'blue-ball-voley',         archivo: 'blue-ball-voley' },
      { nombre: 'blue-calendar',           archivo: 'blue-calendar' },
      { nombre: 'blue-calendar-plus',      archivo: 'blue-calendar-plus' },
      { nombre: 'calendar1',               archivo: 'calendar1' },
      { nombre: 'calendar_add',            archivo: 'calendar_add' },
      { nombre: 'calendar_no',             archivo: 'calendar_no' },
      { nombre: 'calendar_ok',             archivo: 'calendar_ok' },
      { nombre: 'calendar_remove',         archivo: 'calendar_remove' },
      { nombre: 'blue-cancel',             archivo: 'blue-cancel' },
      { nombre: 'blue-cart',               archivo: 'blue-cart' },
      { nombre: 'blue-user-delete',             archivo: 'blue-user-delete' },
      { nombre: 'blue-delete',             archivo: 'blue-delete' },
      { nombre: 'blue-dinero',             archivo: 'blue-dinero' },
      { nombre: 'blue-doc-alert',          archivo: 'blue-doc-alert' },
      { nombre: 'blue-doc-no',             archivo: 'blue-doc-no' },
      { nombre: 'blue-doc-ok',             archivo: 'blue-doc-ok' },
      { nombre: 'blue-doc-temp',           archivo: 'blue-doc-temp' },
      { nombre: 'blue-docs',               archivo: 'blue-docs' },
      { nombre: 'blue-doctor',             archivo: 'blue-doctor' },
      { nombre: 'blue-edit',               archivo: 'blue-edit' },
      { nombre: 'blue-email-alert',        archivo: 'blue-email-alert' },
      { nombre: 'blue-eye',                archivo: 'blue-eye' },
      { nombre: 'blue-face-id',            archivo: 'blue-face-id' },
      { nombre: 'blue-gps',                archivo: 'blue-gps' },
      { nombre: 'blue-graduado',           archivo: 'blue-graduado' },
      { nombre: 'blue-graphic',            archivo: 'blue-graphic' },
      { nombre: 'blue-id-check',           archivo: 'blue-id-check' },
      { nombre: 'blue-image',              archivo: 'blue-image' },
      { nombre: 'blue-intercambiar',       archivo: 'blue-intercambiar' },
      { nombre: 'blue-link',               archivo: 'blue-link' },
      { nombre: 'blue-message',            archivo: 'blue-message' },
      { nombre: 'blue-money-1',            archivo: 'blue-money-1' },
      { nombre: 'blue-phone',              archivo: 'blue-phone' },
      { nombre: 'blue-print',              archivo: 'blue-print' },
      { nombre: 'blue-send-message',       archivo: 'blue-send-message' },
      { nombre: 'blue-settings',           archivo: 'blue-settings' },
      { nombre: 'blue-sheet',              archivo: 'blue-sheet' },
      { nombre: 'blue-sobre',              archivo: 'blue-sobre' },
      { nombre: 'blue-star',               archivo: 'blue-star' },
      { nombre: 'blue-upload',             archivo: 'blue-upload' },
      { nombre: 'blue-user-borrar',        archivo: 'blue-user-borrar' },
      { nombre: 'blue-user-config',        archivo: 'blue-user-config' },
      { nombre: 'blue-user-editar',        archivo: 'blue-user-editar' },
      { nombre: 'download-excel',          archivo: 'download-excel' },
      { nombre: 'download-pdf',            archivo: 'download-pdf' },
      { nombre: 'dislike',                 archivo: 'dislike' },
      { nombre: 'edit',                    archivo: 'edit' },
      { nombre: 'i-apagar',               archivo: 'i-apagar' },
      { nombre: 'i-calendar',             archivo: 'i-calendar' },
      { nombre: 'i-calendar-down',        archivo: 'i-calendar-down' },
      { nombre: 'i-calendar-reload',      archivo: 'i-calendar-reload' },
      { nombre: 'i-calendar-up',          archivo: 'i-calendar-up' },
      { nombre: 'i-cancha',               archivo: 'i-cancha' },
      { nombre: 'i-check',                archivo: 'i-check' },
      { nombre: 'i-mail-no',              archivo: 'i-mail-no' },
      { nombre: 'i-mail-ok',              archivo: 'i-mail-ok' },
      { nombre: 'i-mail-reload',          archivo: 'i-mail-reload' },
      { nombre: 'i-upload',               archivo: 'i-upload' },
      { nombre: 'i-xmark',                archivo: 'i-xmark' },
      { nombre: 'jpg',                     archivo: 'jpg' },
      { nombre: 'like',                    archivo: 'like' },
      { nombre: 'logo',                    archivo: 'logo' },
      { nombre: 'pdf',                     archivo: 'pdf' },
      { nombre: 'tt_crm',                  archivo: 'tt-crm' },
      { nombre: 'tt_configuracion',        archivo: 'configuracion' },
      { nombre: 'tt_cronometro',           archivo: 'cronometro' },
      { nombre: 'tt_equipos',              archivo: 'equipos' },
      { nombre: 'tt_estadio',              archivo: 'estadio' },
      { nombre: 'tt_cancha',               archivo: 'i-cancha' },
      { nombre: 'tt_cancha-add',           archivo: 'i-cancha-add' },
      { nombre: 'tt_persona',              archivo: 'persona' },
      { nombre: 'tt_silbato',              archivo: 'silbato' },
      { nombre: 'tt_tarjeta-morado',       archivo: 'tarjeta-morado' },
      { nombre: 'tt_tarjeta-rojo',         archivo: 'tarjeta-rojo' },
      { nombre: 'tt_trofeo-white',         archivo: 'trophy' },
      { nombre: 'tt-americano-calendar',   archivo: 'tt-americano-calendar' },
      { nombre: 'tt-americano-cancha',     archivo: 'tt-americano-cancha' },
      { nombre: 'tt-americano-chat',       archivo: 'tt-americano-chat' },
      { nombre: 'tt-americano-news',       archivo: 'tt-americano-news' },
      { nombre: 'tt-config',               archivo: 'tt-config' },
      { nombre: 'tt-crm',                  archivo: 'tt-crm' },
      { nombre: 'tt-employee',             archivo: 'tt-employee' },
      { nombre: 'tt-employee-doc',         archivo: 'tt-employee-doc' },
      { nombre: 'tt-face-id',              archivo: 'tt-face-id' },
      { nombre: 'tt-familia',              archivo: 'tt-familia' },
      { nombre: 'tt-goal-americano',       archivo: 'tt-goal-americano' },
      { nombre: 'tt-healthcheckup',        archivo: 'tt-healthcheckup' },
      { nombre: 'tt-marcador',             archivo: 'tt-marcador' },
      { nombre: 'tt-medal',                archivo: 'tt-medal' },
      { nombre: 'tt-money-metrics',        archivo: 'tt-money-metrics' },
      { nombre: 'tt-silbato',              archivo: 'tt-silbato' },
      { nombre: 'tt-soccer-ball',          archivo: 'tt-soccer-ball' },
      { nombre: 'tt-soccer-cancha',        archivo: 'tt-soccer-cancha' },
      { nombre: 'tt-soccer-chat',          archivo: 'tt-soccer-chat' },
      { nombre: 'tt-soccer-trophy',        archivo: 'tt-soccer-trophy' },
      { nombre: 'tt-strategic-planning',   archivo: 'tt-strategic-planning' },
      { nombre: 'whatsapp',                archivo: 'whatsapp' },
      { nombre: 'user-rojo',               archivo: 'user-rojo' },
      { nombre: 'user-verde',              archivo: 'user-verde' },
      { nombre: 'users-config',            archivo: 'users-config' },
      { nombre: 'zip',                     archivo: 'zip' },
      { nombre: 'redes_facebook',          archivo: 'redes_facebook' },
      { nombre: 'redes_googleads',         archivo: 'redes_googleads' },
      { nombre: 'redes_instagram',         archivo: 'redes_instagram' },
      { nombre: 'redes_ligas',             archivo: 'redes_ligas' },
      { nombre: 'redes_referencia',        archivo: 'redes_referencia' },
      { nombre: 'redes_tiktok',            archivo: 'redes_tiktok' },
      { nombre: 'redes_whatsapp',          archivo: 'redes_whatsapp' },
];

@Injectable({ providedIn: 'root' })
export class SvgIconsService {

  constructor(
    private _registry: MatIconRegistry,
    private _sanitizer: DomSanitizer
  ) {}

  public registrarTodos(): void {
    ICONOS_SVG.forEach(({ nombre, archivo }) => {
      this._registry.addSvgIcon(
        nombre,
        this._sanitizer.bypassSecurityTrustResourceUrl(`assets/svg/${archivo}.svg`)
      );
    });
  }
}
